<ng-container *ngIf="!isFamilyListLoading; else loading">
    <div class="patients-list-container" *ngIf="familyPatients.length > 0; else noFamily">
      <h2 class="list-title">Select an account</h2>
    
      <!-- Repeat for each patient in familyPatients -->
      <div
        class="account-item"
        [ngClass]="{'selected': selectedPatient && (selectedPatient === patient)}"
        *ngFor="let patient of familyPatients"
        (click)="onSelectPatient(patient)"
      >
        <!-- Circle with user initials -->
        <div class="account-initials">
          {{ getInitials(patient.firstName, patient.lastName) }}
        </div>
    
        <!-- Patient name & optional subtitle -->
        <div class="account-details">
          <p class="account-name" *ngIf="patient?.firstName || patient?.lastName">{{ patient.firstName }} {{ patient.lastName }}</p>
          <p class="account-subtitle" *ngIf="patient?.dateOfBirth">
            {{ patient.dateOfBirth | date: 'MM/dd/yyyy' }}
          </p>
        </div>
      </div>
    </div>
    
    <ng-template #noFamily>
      <p>No family members found.</p>
    </ng-template>
  </ng-container>
  
  <ng-template #loading>
    <div class="loading-container">
      <mat-spinner diameter="20" color="primary"></mat-spinner>
    </div>
  </ng-template>